<template>
  <!--订单继续支付-->
  <div id="orderrepaying">
    <div class="processing">
      <h3>
        {{msg}}<br>
      </h3>
      <div>
        <img src="@/assets/icon/orderpaying_icon_process.gif" alt="">
      </div>
      <div class="chooseNext">
        <router-link :to="{name: 'MyOrder'}">放弃支付</router-link>
        <a @click="payFailed">支付完成</a>
      </div>
      <router-link :to="{name: 'MyOrder'}" class="close" href="">&times;</router-link>
    </div>
    <form action="/api/app/v1/post_order_again_payment" method="post" ref="buy">
      <input type="hidden" name="shop_id" :value="this.$route.params.shop_id">
      <input type="hidden" name="payment_method" :value="this.$route.params.payment_method">
      <input type="hidden" name="_sign" :value="this.$route.params._sign">
    </form>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'OrderRepaying',
  data () {
    return {
      msg: '支付进行中...请稍后',
      orderState: -1, // 订单支付状态：-1 未支付 0 正在支付 1 支付完成
      intervalCheck: {},
      shopNumber: this.$route.query.shop_number,
      onlyCheck: JSON.stringify(this.$route.params) === '{}' // 判断是支付提交订单or微信返回订单
    }
  },
  methods: {
    // 查询订单状态
    getOrderStatus () {
      let data = {
        shop_number: this.shopNumber
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_shop_number_state',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.orderState = res.data.data.state
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 提交form支付请求到后端页面
    submitPay () {
      this.checkOrderStatus()
      this.$refs.buy.submit()
    },
    checkOrderStatus () {
      this.intervalCheck = setInterval(() => {
        this.getOrderStatus()
        if (this.orderState === 1) {
          this.msg = '支付成功，正在跳转..'
          this.$router.push({name: 'PaySuccess'})
          clearInterval(this.intervalCheck)
        }
      }, 1000)
    },
    payFailed () {
      if (this.orderState === 1) {
        this.$router.push({name: 'PaySuccess'})
      } else {
        this.$router.push({name: 'MyOrder'})
      }
    }
  },
  mounted () {
    if (this.onlyCheck) {
      this.checkOrderStatus()
    } else {
      this.submitPay()
    }
  },
  destroyed () {
    clearInterval(this.intervalCheck)
  }
}
</script>

<style scoped lang="stylus">
  #orderrepaying
    .processing
      position: fixed
      top: 50%
      left: 50%
      z-index: 100
      width: 5.9rem
      height: 3.6rem
      background-color: #fff
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      h3
        margin: .62rem 0 .26rem
        font-size: .36rem
        color: #333
        text-align: center
      & > div img
        display: block
        margin: .2rem auto
      p
        padding: 0
        margin: 0 auto
        font-size: .32rem
        color: #666
        text-align: center
        b
          color: #FF7052
          font-weight: 500
      .sub
        display: flex
        justify-content: space-between
        width: 4.38rem
        height: .68rem
        margin: .42rem auto
        a
          display: inline-block
          width: 2rem
          height: .68rem
          line-height: .64rem
          border: .02rem solid #FF7052
          color: #FF7052
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
          &:first-child
            background-color: #FF7052
            color: #fff
      a.close
        position: absolute
        top: .2rem
        right: .2rem
        display: block
        width: .3rem
        height: .3rem
        line-height: .24rem
        font-size: .4rem
        text-align: center
      .chooseNext
        display: flex
        justify-content: space-between
        align-items: center
        width: 3.5rem
        height: 1rem
        margin: 0 auto
        a
          display: block
          width: 1.5rem
          height: .6rem
          line-height: .56rem
          border: .02rem solid #ff7052
          font-size: .2rem
          color: #ff7052
          text-align: center
          -webkit-border-radius: .05rem
          -moz-border-radius: .05rem
          border-radius: .05rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &:last-child
            background-color: #ff7052
            color: #fff
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 50
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/order/OrderRepaying.vue